var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-subject"},[_c('CardTitle',[_vm._v(_vm._s(_vm.titleName))]),_c('div',{staticClass:"subject-count"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }